/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { CashDrawerDTO } from "../model";
import { CashDrawerDTOTrackedI, CashDrawerDTOMeta } from "../model";
// @ts-ignore
import type { CheckoutSessionDTO } from "../model";
import { CheckoutSessionDTOTrackedI, CheckoutSessionDTOMeta } from "../model";
// @ts-ignore
import type { CreateOrderPaymentDTO } from "../model";
import {
  CreateOrderPaymentDTOTrackedI,
  CreateOrderPaymentDTOMeta,
} from "../model";
// @ts-ignore
import type { CreateOrderPaymentResponseDTO } from "../model";
import {
  CreateOrderPaymentResponseDTOTrackedI,
  CreateOrderPaymentResponseDTOMeta,
} from "../model";
// @ts-ignore
import type { EditCashDrawersDTO } from "../model";
import { EditCashDrawersDTOTrackedI, EditCashDrawersDTOMeta } from "../model";
// @ts-ignore
import type { OrderDTO } from "../model";
import { OrderDTOTrackedI, OrderDTOMeta } from "../model";
// @ts-ignore
import type { PaymentStatus } from "../model";
import { PaymentStatusTrackedI, PaymentStatusMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Creates a payment intent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCheckoutSessionGet: (
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/member/checkout-session`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cancels a payment
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentCancelIdPost: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("memberPaymentCancelIdPost", "id", id);
      const localVarPath = `/member/payment/cancel/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentPost: (
      createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'createOrderPaymentDTO' is not null or undefined
      assertParamExists(
        "memberPaymentPost",
        "createOrderPaymentDTO",
        createOrderPaymentDTO,
      );
      const localVarPath = `/member/payment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPaymentDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Polls payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsIdPollPost: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("paymentsIdPollPost", "id", id);
      const localVarPath = `/payments/{id}/poll`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns cash drawers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersGet: (options: RawAxiosRequestConfig = {}): RequestArgs => {
      const localVarPath = `/staff/cash-drawers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Updated cash drawers
     * @param {EditCashDrawersDTO} editCashDrawersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersPost: (
      editCashDrawersDTO: EditCashDrawersDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'editCashDrawersDTO' is not null or undefined
      assertParamExists(
        "staffCashDrawersPost",
        "editCashDrawersDTO",
        editCashDrawersDTO,
      );
      const localVarPath = `/staff/cash-drawers`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        editCashDrawersDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a checkout session
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckoutSessionIdGet: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("staffCheckoutSessionIdGet", "id", id);
      const localVarPath = `/staff/checkout-session/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Cancels a payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentCancelIdPost: (
      id: number,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("staffPaymentCancelIdPost", "id", id);
      const localVarPath = `/staff/payment/cancel/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(id)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates test payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentPost: (
      createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'createOrderPaymentDTO' is not null or undefined
      assertParamExists(
        "staffPaymentPost",
        "createOrderPaymentDTO",
        createOrderPaymentDTO,
      );
      const localVarPath = `/staff/payment`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createOrderPaymentDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type memberCheckoutSessionGetParams = {};
export type memberPaymentCancelIdPostParams = { id: number };
export type memberPaymentPostParams = {
  createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI;
};
export type paymentsIdPollPostParams = { id: number };
export type staffCashDrawersGetParams = {};
export type staffCashDrawersPostParams = {
  editCashDrawersDTO: EditCashDrawersDTOTrackedI;
};
export type staffCheckoutSessionIdGetParams = { id: number };
export type staffPaymentCancelIdPostParams = { id: number };
export type staffPaymentPostParams = {
  createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI;
};

export const memberCheckoutSessionGetMeta = {};
export const memberPaymentCancelIdPostMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const memberPaymentPostMeta = {
  createOrderPaymentDTO: propertyMeta(
    "createOrderPaymentDTO",
    false,
    true,
    false,
    CreateOrderPaymentDTOMeta,
  ),
};
export const paymentsIdPollPostMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffCashDrawersGetMeta = {};
export const staffCashDrawersPostMeta = {
  editCashDrawersDTO: propertyMeta(
    "editCashDrawersDTO",
    false,
    true,
    false,
    EditCashDrawersDTOMeta,
  ),
};
export const staffCheckoutSessionIdGetMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffPaymentCancelIdPostMeta = {
  id: propertyMeta("id", false, true, false, MetaTypesBase.number),
};
export const staffPaymentPostMeta = {
  createOrderPaymentDTO: propertyMeta(
    "createOrderPaymentDTO",
    false,
    true,
    false,
    CreateOrderPaymentDTOMeta,
  ),
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const usePaymentApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Creates a payment intent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCheckoutSessionGetRaw(
      props: memberCheckoutSessionGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckoutSessionDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCheckoutSessionGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberCheckoutSessionGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CheckoutSessionDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CheckoutSessionDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels a payment
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentCancelIdPostRaw(
      props: memberPaymentCancelIdPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberPaymentCancelIdPost(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberPaymentCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentPostRaw(
      props: memberPaymentPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberPaymentPost(
        props.createOrderPaymentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberPaymentPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateOrderPaymentResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateOrderPaymentResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Polls payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsIdPollPostRaw(
      props: paymentsIdPollPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentStatus> {
      const localVarAxiosArgs = localVarAxiosParamCreator.paymentsIdPollPost(
        props.id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentsIdPollPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentStatus>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentStatus", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns cash drawers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersGetRaw(
      props: staffCashDrawersGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CashDrawerDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCashDrawersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCashDrawersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<CashDrawerDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<CashDrawerDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updated cash drawers
     * @param {EditCashDrawersDTO} editCashDrawersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersPostRaw(
      props: staffCashDrawersPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CashDrawerDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCashDrawersPost(
        props.editCashDrawersDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCashDrawersPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<CashDrawerDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<CashDrawerDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a checkout session
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckoutSessionIdGetRaw(
      props: staffCheckoutSessionIdGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckoutSessionDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCheckoutSessionIdGet(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCheckoutSessionIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CheckoutSessionDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CheckoutSessionDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels a payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentCancelIdPostRaw(
      props: staffPaymentCancelIdPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPaymentCancelIdPost(props.id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffPaymentCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates test payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentPostRaw(
      props: staffPaymentPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPaymentPost(
        props.createOrderPaymentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffPaymentPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateOrderPaymentResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateOrderPaymentResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Creates a payment intent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberCheckoutSessionGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckoutSessionDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberCheckoutSessionGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberCheckoutSessionGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CheckoutSessionDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CheckoutSessionDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels a payment
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentCancelIdPost(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.memberPaymentCancelIdPost(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberPaymentCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    memberPaymentPost(
      createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponseDTO> {
      authStore.requireAuth([
        // authentication member required
        "member",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.memberPaymentPost(
        createOrderPaymentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.memberPaymentPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateOrderPaymentResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateOrderPaymentResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Polls payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    paymentsIdPollPost(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PaymentStatus> {
      const localVarAxiosArgs = localVarAxiosParamCreator.paymentsIdPollPost(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.paymentsIdPollPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PaymentStatus>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PaymentStatus", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Returns cash drawers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersGet(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CashDrawerDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCashDrawersGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCashDrawersGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<CashDrawerDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<CashDrawerDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Updated cash drawers
     * @param {EditCashDrawersDTO} editCashDrawersDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCashDrawersPost(
      editCashDrawersDTO: EditCashDrawersDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<CashDrawerDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCashDrawersPost(
        editCashDrawersDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCashDrawersPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<CashDrawerDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<CashDrawerDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a checkout session
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckoutSessionIdGet(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CheckoutSessionDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffCheckoutSessionIdGet(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffCheckoutSessionIdGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CheckoutSessionDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CheckoutSessionDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Cancels a payment
     * @param {number} id The payment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentCancelIdPost(
      id: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<OrderDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs =
        localVarAxiosParamCreator.staffPaymentCancelIdPost(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffPaymentCancelIdPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<OrderDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("OrderDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates test payment intent
     * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffPaymentPost(
      createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CreateOrderPaymentResponseDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffPaymentPost(
        createOrderPaymentDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["PaymentApi.staffPaymentPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<CreateOrderPaymentResponseDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("CreateOrderPaymentResponseDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * PaymentApi - interface
 * @export
 * @interface PaymentApi
 */
export interface PaymentApiInterface {
  /**
   * Creates a payment intent
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  memberCheckoutSessionGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CheckoutSessionDTO>;

  /**
   * Cancels a payment
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  memberPaymentCancelIdPost(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Creates a payment intent
   * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  memberPaymentPost(
    createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CreateOrderPaymentResponseDTO>;

  /**
   * Polls payment
   * @param {number} id The payment ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  paymentsIdPollPost(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PaymentStatus>;

  /**
   * Returns cash drawers
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  staffCashDrawersGet(
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<CashDrawerDTO>>;

  /**
   * Updated cash drawers
   * @param {EditCashDrawersDTO} editCashDrawersDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  staffCashDrawersPost(
    editCashDrawersDTO: EditCashDrawersDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<CashDrawerDTO>>;

  /**
   * Creates a checkout session
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  staffCheckoutSessionIdGet(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CheckoutSessionDTO>;

  /**
   * Cancels a payment
   * @param {number} id The payment ID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  staffPaymentCancelIdPost(
    id: number,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<OrderDTO>;

  /**
   * Creates test payment intent
   * @param {CreateOrderPaymentDTO} createOrderPaymentDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PaymentApiInterface
   */
  staffPaymentPost(
    createOrderPaymentDTO: CreateOrderPaymentDTOTrackedI,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<CreateOrderPaymentResponseDTO>;
}
